(() => {
  'use strict';
  const root = document.querySelector('[data-nt-timer]');
  if (!root) return;
  const hours = Number(root.dataset.hours || 24);
  const KEY = 'nt_renew25_timer_start';
  let start = Number(sessionStorage.getItem(KEY));
  if (!start || isNaN(start)) {
    start = Date.now();
    try { sessionStorage.setItem(KEY, String(start)); } catch {}
  }
  const ends = start + hours * 3600 * 1000;

  const els = {
    h_tens: root.querySelector('[data-h-tens]'),
    h_ones: root.querySelector('[data-h-ones]'),
    m_tens: root.querySelector('[data-m-tens]'),
    m_ones: root.querySelector('[data-m-ones]'),
    s_tens: root.querySelector('[data-s-tens]'),
    s_ones: root.querySelector('[data-s-ones]'),
  };

  const reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Each digit holds a resting value in a .nt-timer__base span; transient cells animate over it.
  Object.values(els).forEach((el) => {
    if (!el) return;
    const v = (el.textContent || '0').trim();
    el.dataset.val = v;
    el.innerHTML = '<span class="nt-timer__base">' + v + '</span>';
  });
  const makeCell = (v, cls) => {
    const c = document.createElement('span');
    c.className = 'nt-timer__cell ' + cls;
    c.textContent = v;
    return c;
  };

  let id;
  function tick(animate) {
    const remain = Math.max(0, ends - Date.now());
    const total = Math.floor(remain / 1000);
    const h = Math.floor(total / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = total % 60;
    const set = (el, n) => {
      const next = String(n);
      if (!el || el.dataset.val === next) return;
      const prev = el.dataset.val;
      el.dataset.val = next;
      const base = el.querySelector('.nt-timer__base');
      if (!animate || reduceMotion || prev === undefined) { base.textContent = next; return; }
      // clear any in-flight cells, then roll: old fades out + up, new fades in + up
      el.querySelectorAll('.nt-timer__cell').forEach((c) => c.remove());
      base.textContent = next;
      el.classList.add('is-animating');
      const oldCell = makeCell(prev, 'nt-timer__cell--old');
      const newCell = makeCell(next, 'nt-timer__cell--new');
      el.appendChild(oldCell);
      el.appendChild(newCell);
      const done = (e) => {
        if (e.target !== newCell) return;
        newCell.removeEventListener('animationend', done);
        oldCell.remove();
        newCell.remove();
        el.classList.remove('is-animating');
      };
      newCell.addEventListener('animationend', done);
    };
    set(els.h_tens, Math.floor(h / 10));
    set(els.h_ones, h % 10);
    set(els.m_tens, Math.floor(m / 10));
    set(els.m_ones, m % 10);
    set(els.s_tens, Math.floor(s / 10));
    set(els.s_ones, s % 10);
    if (remain <= 0) { clearInterval(id); }   /* stop at zero; do NOT fade the banner */
  }
  tick(false); // first paint: set values without animating
  id = setInterval(() => tick(true), 1000);
})();

// ── Sticky offset sync ────────────────────────────────────────────────────
// The timer banner sticks directly beneath the sticky header. The header's
// height is NOT a fixed value: on tablet (769–942px) it's a two-row grid whose
// height grows when the nav wraps (~104px → ~154px), and the logo image / web
// fonts shift it as they load. A hardcoded `top` left the timer pinned under a
// taller header, so the header (z-index 1000) sat over the banner and cut it
// off — fully hidden at 769–820, ~30% clipped at 900–942. Measure the header
// and drive the timer's sticky `top` from it, so the banner always lands flush
// below the header at every width. (The header sticks at top:-1px, hence −1.)
(() => {
  'use strict';
  const header = document.getElementById('shopify-section-nt-renew25-header');
  const timer = document.getElementById('shopify-section-nt-renew25-timer');
  if (!header || !timer) return;
  const sync = () => {
    const h = Math.round(header.getBoundingClientRect().height);
    if (h > 0) timer.style.top = (h - 1) + 'px';
  };
  sync();
  window.addEventListener('load', sync);
  window.addEventListener('resize', sync);
  // Catches nav-wrap, logo-image load, and font-swap height changes.
  if ('ResizeObserver' in window) new ResizeObserver(sync).observe(header);
})();
